module.exports = __webpack_public_path__ + "img/logo2.096f9c3b.png";